import { SearchState } from '@/types/models'
import { generateSponsorTierOptionalFilters } from '@/domain/search/generateSponsorTierOptionalFilters'
import { isNil, isNonEmptyObject, isNonEmptyString } from '@/utils/checks'
import { getSpecializationsFromSearchState } from '@/domain/search/getSpecializationsFromSearchState'
import { browseWeights } from './constants'
import { PrimaryFocus } from '../primaryFocus/constant'
export const addOptionalFilters = ({
  searchState,
  primaryFocus,
  optionaFilterWeights
}: {
  searchState: SearchState
  primaryFocus?: PrimaryFocus
  optionaFilterWeights?: {
    SPECIALIZATION_BOOST: number
    PRIMARY_FOCUS_BOOST: number
    SPONSOR_BOOST: number
  }
}): Array<string | Array<string>> => {
  const optionalFilters: Array<string | Array<string>> = []
  // TODO: Remove all playground based references before release https://linear.app/rehabpath/issue/SOFT-761/remove-playground-based-code
  const { SPECIALIZATION_BOOST, PRIMARY_FOCUS_BOOST, SPONSOR_BOOST } =
    optionaFilterWeights || browseWeights
  optionalFilters.push(
    ...generateSponsorTierOptionalFilters({
      sponsorBoost: SPONSOR_BOOST
    })
  )
  if (isNonEmptyObject(searchState?.refinementList)) {
    optionalFilters.push(
      ...getSpecializationsFromSearchState({
        searchState: searchState.refinementList,
        specializationBoost: SPECIALIZATION_BOOST
      })
    )
  }
  if (
    isNonEmptyString(primaryFocus) &&
    !isNil(PRIMARY_FOCUS_BOOST) &&
    primaryFocus === PrimaryFocus.EATING_DISORDERS
  ) {
    optionalFilters.push(
      `primaryFocus:${primaryFocus}<score=${PRIMARY_FOCUS_BOOST}>`
    )
  }

  return optionalFilters
}
